module.exports = __webpack_public_path__ + "img/camera.33a6660a.png";